import {createGlobalStyle} from 'styled-components';
import {warpContext} from '../Step/Step.css';
import zIndex from '../../../../globalVariables/zIndex';

export const globalStyle = createGlobalStyle`
  ${warpContext}{
   z-index: ${zIndex.baseHighest};
  }
`;